import * as types from '../mutation-types'

export default {
    namespaced: true,

    state: {
        transactionBonds: []
    },

    actions: {
        fetchMaterialFlow({ commit }, { fromDate, toDate }) {
            return window.axios.get('MaterialFlow/TransactionBonds', { params: { fromDate, toDate } }).then(({ data }) => {
                commit(types.STORE_TRANSACTION_BONDS, data)
                return data
            })
        },

        create(_, { date }) {
            return window.axios.post('MaterialFlow/TransactionBonds', {}, { params: { date } }).then((data) => {
                return data
            })
        },

        delete(_, { transactionBondId }) {
            return window.axios.delete(`/MaterialFlow/TransactionBonds/${transactionBondId}`).then((data) => {
                return data
            })
        },

        fetchEntry(_, { entryId }) {
            return window.axios.get(`materialFlow/transactionBonds/transactionBondsEntries/${entryId}`).then(({ data }) => {
                return data
            })
        },

        createEntry(_, { source_warehouse_id, target_warehouse_id, source_material_id, target_material_id, transaction_bond_id, quantity, notes, date }) {
            return window.axios.post('MaterialFlow/transactionBonds/Entries', { source_warehouse_id, target_warehouse_id, source_material_id, target_material_id, transaction_bond_id, quantity, notes, date }).then(({ data }) => {
                return data
            })
        },

        updateEntry(_, { source_warehouse_id, target_warehouse_id, source_material_id, target_material_id, transaction_bond_id, quantity, notes, date, entryId }) {
            return window.axios.put(`/MaterialFlow/TransactionBonds/Entries/${entryId}`, { source_warehouse_id, target_warehouse_id, source_material_id, target_material_id, transaction_bond_id, quantity, notes, date }).then((data) => {
                return data
            })
        },

        deleteEntry(_, { transactionBondId, entryId }){
            return window.axios.delete(`materialFlow/TransactionBonds/entries/${entryId}`, {
                params: { transactionBondId }
            })
        },

        fetchEntries(_, { transactionBondId }) {
            return window.axios.get(`materialFlow/transactionBonds/${transactionBondId}/entries`).then((data) => {
                return data
            })
        },

        fetchJournalByNo(_, { transactionBondNo }) {
            return window.axios.get(`/MaterialFlow/TransactionBonds/No/${transactionBondNo}`).then((data) => {
                return data
            })
        },

        posted(_, { transactionBondId }) {
            return window.axios.put(`/materialFlow/transactionBonds/${transactionBondId}/ChangeToPosted`).then((data) => {
                return data
            })
        },

        unPosted(_,{ transactionBondId }) {
            return window.axios.put(`/materialFlow/transactionBonds/${transactionBondId}/ChangeToNotPosted`).then((data) => {
                return data
            })
        }
    },

    mutations: {
        [types.STORE_TRANSACTION_BONDS](state, transactionBonds) {
            state.transactionBonds = transactionBonds
        }
    }
}